import ajax from './index'
import axios from 'axios' 


//小店会员列表
export function shopvipList(url){
     return ajax.get('/admin/shop/shop_vip/list?'+url)
}

//会员商品订单
export function orderUserProductOrderList(url){
     return ajax.get('/admin/order/user/product_order/list?'+url)
}

//会员现金券订单
export function orderUserCashCouponOrderList(url){
     return ajax.get('/admin/order/user/cash_coupon_order/list?'+url)
}

//用户信息
export  function userProfileData(url){
     return ajax.get('/admin/user/user_profile?'+url)
}

//已加入会员小店信息
export function userShopVipList(url){
     return ajax.get('/admin/shop/user/shop_vip/list?'+url)
}

//禁用某条会员
export function shopVipDisable(url){
     return ajax.post('/admin/shop/shop_vip/disable?'+url)
}
//移除某个用户所有会员
export function shopUserVipDisable(url){
     return ajax.post('/admin/shop/user/shop_vip/disable?'+url) 
}
//会员卡列表
export function cardXiList(data){
     return ajax.post('/admin/card/xi/list',data)
}

//删除会员卡
export function cardXiDelete(data){
     return ajax.post('/admin/card/xi/delete',data)
}

//会员卡详情
export function cardXiDetail(data){
     return ajax.post('/admin/card/xi/detail',data)
}

//获取小程序二维码
export function cardXiQRcode(data){
     return ajax.post('/admin/card/xi/qrcode',data)
}
//检车卡号段是否可用
export function  cardXiCheck(data){
     return ajax.post('/admin/card/xi/check',data)
}

//添加卡号段
export function cardXiAdd(data){
     axios.defaults.timeout = 20000;
     return ajax.post('/admin/card/xi/add',data)
}

//绑定卡号段
export function cardXiBind(data){
     return ajax.post('/admin/card/xi/bind',data)
}

//用户充值记录
export function cardUserIdIncomeSearch(id,url){
     return ajax.get('/admin/card/user/'+id+'/income/search?'+url)
}


//会员-所有会员卡退费
export function refundAllVipCardmoney(data){
     return ajax.post('/admin/shop/vip_user/refund_all_vip_card_money',data)
}

//会员-会员卡退费
export function  refundVipCardMoney(data){
     return ajax.post('/admin/shop/vip_user/refund_vip_card_money',data)
}

//会员激励
export function userShopVipOrderList(url){
     return ajax.get('/admin/shop/user/shop_vip/order/list?'+url)
}

//红包使用记录
export function userCardConsumeRecord(id,url){
     return ajax.get('/admin/card/user/'+id+'/consume/search?'+url)
}
